if (!customElements.get('collection-items')) {
  class CollectionItems extends HTMLElement {
    constructor() {
      super();

      this.handleUpdateRef = this.handleUpdate.bind(this);
    }

    handleUpdate(event) {
      if (event.detail.id != this.getAttribute('data-id')) return;

      const parser = new DOMParser().parseFromString(
        event.detail.html,
        'text/html',
      );

      const countElement = parser.querySelector('update-collection-count');
      const currentCountElement = document.querySelector(
        'update-collection-count',
      );

      if (countElement && currentCountElement) {
        currentCountElement.setAttribute(
          'data-count',
          countElement.getAttribute('data-count'),
        );
      }

      const items = parser.querySelector('collection-items');
      if (!items) return;

      this.innerHTML = items.innerHTML;
    }

    disconnectedCallback() {
      document.removeEventListener(
        'exo:update-collection-items',
        this.handleUpdateRef,
      );
    }

    connectedCallback() {
      document.addEventListener(
        'exo:update-collection-items',
        this.handleUpdateRef,
      );
    }
  }

  customElements.define('collection-items', CollectionItems);
}
